import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./WhyChooseAbout.css";

import centerImg from "../images/gall3.webp"; // replace with your image
  import Aos from "aos";
  import "aos/dist/aos.css";
  import { useEffect } from "react";
  

export default function WhyChooseAbout() {

    useEffect(() => {
    Aos.init({
      duration: 1000,      // animation duration
      easing: "ease-in-out",
      once: true,          // animation happens only once
      offset: 100,         // offset from the trigger point
    });
  
    Aos.refresh(); // optional but recommended
  }, []);
  
  return (
    <section className="container-fluid prana-why-section " >
      <div className="container"  data-aos="fade-up"
     data-aos-duration="3000">

        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="prana-title head-font">
            Why Choose Ayur Moksha
          </h2>
          <p className="prana-subtitle para-font">
          Think of Ayur Moksha as your second home, where healing, comfort, and balance guide you back to your natural state of health.
          </p>
        </div>

        {/* Main Grid */}
        <div className="row g-4 align-items-stretch">

          {/* LEFT CARD */}
          <div className="col-lg-4">
            <div className="prana-card h-100">
              <div className="prana-card-block">
                <span className="prana-icon">🪔</span>
                <h5 className="head-font">Personalized Treatments</h5>
                <p style={{fontSize:'15px'}} className="para-font justify-text">
                 Every therapy is thoughtfully tailored to your unique body constitution (Prakriti) and current health concerns. Our Ayurvedic experts carefully assess your lifestyle, imbalances, and wellness goals to design treatments that work in harmony with your body. This personalized approach ensures deeper healing, long-lasting results, and a truly nurturing journey toward balance, vitality, and overall well-being.
                </p>
              </div>

              <hr  style={{backgroundColor:'white'}}/>

              <div className="prana-card-block">
                <span className="prana-icon">🪔</span>
                <h5 className="head-font">Holistic Healing Approach</h5>
                <p style={{fontSize:'15px'}} className="para-font justify-text">
                  We focus on treating the root cause rather than just relieving symptoms, following the true principles of Ayurveda. By thoughtfully combining therapeutic treatments, personalized dietary guidance, and mindful lifestyle practices, we help restore balance to the mind, body, and spirit—promoting deep healing, long-term wellness, and inner harmony.
                </p>
              </div>
            </div>
          </div>

          {/* CENTER IMAGE */}
          <div className="col-lg-4">
            <div className="prana-center-image h-100">
              <img src={centerImg} alt="Ayurveda Therapy" />
            </div>
          </div>

          {/* RIGHT CARD */}
          <div className="col-lg-4">
            <div className="prana-card h-100">
              <div className="prana-card-block">
                 <span className="prana-icon">🪔</span>
                <h5 className="head-font">Peaceful Environment</h5>
                <p style={{fontSize:'15px'}} className="para-font justify-text">
                  Immerse yourself in a serene, nature-inspired atmosphere designed to calm your senses and quiet the mind. Surrounded by soothing greenery, gentle natural elements, and tranquil spaces, our environment supports deep relaxation, emotional balance, and a truly restorative healing experience.
                </p>
              </div>

              <hr style={{backgroundColor:'white'}} />

              <div className="prana-card-block">
                 <span className="prana-icon">🪔</span>
                <h5 className="head-font">Trusted Practitioners</h5>
                <p style={{fontSize:'15px'}} className="para-font justify-text">
                 Our team of experienced Ayurvedic doctors and skilled therapists combine authentic traditional knowledge with compassionate care. Every treatment is guided by expertise, attention, and a deep commitment to your well-being, ensuring safe, effective, and personalized healing.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
